import React from 'react';

import { Button } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core-react/i18n';

import { EmptyStateCtaPanel } from '../../../EmptyStateCtaPanel';

import { useCreateVideo } from './hooks/useCreateVideo';

export const CreateVideo: React.FC = () => {
	const {
		data: { username, userHasSigned },
		actions: { createVideoClickHandler },
	} = useCreateVideo();

	const { translate } = useI18n();

	const message = userHasSigned
		? translate('corgi.petition_gamma.videos.cta.with_name', { username })
		: translate('corgi.petition_gamma.videos.cta.without_name');

	const buttonText = translate('corgi.petition_gamma.videos.create');

	return (
		<EmptyStateCtaPanel
			message={message}
			callToActionSlot={
				userHasSigned ? (
					<Button
						variant="primary"
						onClick={createVideoClickHandler}
						data-testid="create-video-button"
						data-qa="create-video-button"
					>
						{buttonText}
					</Button>
				) : undefined
			}
		/>
	);
};
